module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO28DiferentesTiposDeGastosa.c2a05a3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO28DiferentesTiposDeGastosa.mp4
// module id = 754
// module chunks = 1